module.exports = "<uoz-table [dataSource]=\"users\" [displayedColumns]=\"displayedColumns\"></uoz-table>\n"